/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invalidlinkdesc2Inputs */

const zh_auth_invalidlinkdesc2 = /** @type {(inputs: Auth_Invalidlinkdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此密码重置链接无效或已过期，请重新申请。`)
};

const en_auth_invalidlinkdesc2 = /** @type {(inputs: Auth_Invalidlinkdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This password reset link is invalid or has expired. Please request a new one.`)
};

const es_auth_invalidlinkdesc2 = /** @type {(inputs: Auth_Invalidlinkdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este enlace de restablecimiento es inválido o ha expirado. Solicita uno nuevo.`)
};

/**
* | output |
* | --- |
* | "This password reset link is invalid or has expired. Please request a new one." |
*
* @param {Auth_Invalidlinkdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_invalidlinkdesc2 = /** @type {((inputs?: Auth_Invalidlinkdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invalidlinkdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_invalidlinkdesc2(inputs)
	if (locale === "en") return en_auth_invalidlinkdesc2(inputs)
	return es_auth_invalidlinkdesc2(inputs)
});
export { auth_invalidlinkdesc2 as "auth_invalidLinkDesc" }